/**
 * Projektmanagement-Permissions — gespiegelt von PM-API (Port 9700).
 * Verwendung im Frontend für RequirePermission-Wrapper + Sidebar-Filter.
 *
 * Strukturell verschachtelt: PROJECT_PERMISSIONS.STAKEHOLDER.READ === 'stakeholder.read'.
 * Quelle: smspro/api/projectmanagement/packages/shared/src/constants/permissions.ts
 */
export const PROJECT_PERMISSIONS = {
    PROJECT_TYPE: {
        READ: 'project_type.read',
        CREATE: 'project_type.create',
        UPDATE: 'project_type.update',
        DELETE: 'project_type.delete',
    },
    COST_ELEMENT: {
        READ: 'cost_element.read',
        CREATE: 'cost_element.create',
        UPDATE: 'cost_element.update',
        DELETE: 'cost_element.delete',
    },
    PROJECT: {
        LIST: 'project.list',
        READ: 'project.read',
        CREATE: 'project.create',
        UPDATE: 'project.update',
        DELETE: 'project.delete',
    },
    MILESTONE: {
        READ: 'milestone.read',
        CREATE: 'milestone.create',
        UPDATE: 'milestone.update',
        DELETE: 'milestone.delete',
    },
    TASK: {
        READ: 'task.read',
        CREATE: 'task.create',
        UPDATE: 'task.update',
        DELETE: 'task.delete',
    },
    WORK_LOG: {
        READ: 'work_log.read',
        CREATE: 'work_log.create',
        UPDATE: 'work_log.update',
        DELETE: 'work_log.delete',
        BOOK: 'work_log.book',
        UNBOOK: 'work_log.unbook',
    },
    TASK_SKILL: {
        READ: 'task_skill.read',
        UPDATE: 'task_skill.update',
    },
    STAKEHOLDER: {
        READ: 'stakeholder.read',
        CREATE: 'stakeholder.create',
        UPDATE: 'stakeholder.update',
        DELETE: 'stakeholder.delete',
    },
    ANFORDERUNG: {
        READ: 'anforderung.read',
        CREATE: 'anforderung.create',
        UPDATE: 'anforderung.update',
        DELETE: 'anforderung.delete',
    },
    ARBEITSPAKET: {
        READ: 'arbeitspaket.read',
        CREATE: 'arbeitspaket.create',
        UPDATE: 'arbeitspaket.update',
        DELETE: 'arbeitspaket.delete',
    },
    RISIKO: {
        READ: 'risiko.read',
        CREATE: 'risiko.create',
        UPDATE: 'risiko.update',
        DELETE: 'risiko.delete',
    },
    MEETING: {
        READ: 'meeting.read',
        CREATE: 'meeting.create',
        UPDATE: 'meeting.update',
        DELETE: 'meeting.delete',
    },
    // Tenant-weite, projektuebergreifende Meetings (Timeline). Nicht projektgebunden.
    GLOBAL_MEETING: {
        READ: 'global_meeting.read',
        CREATE: 'global_meeting.create',
        UPDATE: 'global_meeting.update',
        DELETE: 'global_meeting.delete',
    },
    OFFENER_PUNKT: {
        READ: 'offener_punkt.read',
        CREATE: 'offener_punkt.create',
        UPDATE: 'offener_punkt.update',
        DELETE: 'offener_punkt.delete',
    },
    TEAM: {
        READ: 'team.read',
        CREATE: 'team.create',
        UPDATE: 'team.update',
        DELETE: 'team.delete',
    },
    RETRO: {
        READ: 'retro.read',
        CREATE: 'retro.create',
        UPDATE: 'retro.update',
        DELETE: 'retro.delete',
    },
    WEEKLY_PROGRESS: {
        READ: 'weekly_progress.read',
        CREATE: 'weekly_progress.create',
        UPDATE: 'weekly_progress.update',
        DELETE: 'weekly_progress.delete',
    },
    REIFEGRAD: {
        READ: 'reifegrad.read',
        UPDATE: 'reifegrad.update',
    },
    PROJECT_CONFIG: {
        READ: 'project_config.read',
        UPDATE: 'project_config.update',
    },
    PROJECT_INITIALIZATION: {
        READ: 'project_initialization.read',
        CREATE: 'project_initialization.create',
        UPDATE: 'project_initialization.update',
        DELETE: 'project_initialization.delete',
    },
    PROJECT_UNCERTAINTIES: {
        READ: 'project_uncertainties.read',
        CREATE: 'project_uncertainties.create',
        UPDATE: 'project_uncertainties.update',
        DELETE: 'project_uncertainties.delete',
    },
    PROJECT_ABSCHLUSS: {
        READ: 'project_abschluss.read',
        CREATE: 'project_abschluss.create',
        UPDATE: 'project_abschluss.update',
        DELETE: 'project_abschluss.delete',
    },
};
//# sourceMappingURL=projectPermissions.js.map